<template>
  <div>
    <b-table-simple caption-top responsive bordered>
      <b-thead head-variant="light">
        <b-tr>
          <b-th class="text-center">STT</b-th>
          <b-th class="text-center">Level</b-th>
          <b-th class="text-center">Mission Name</b-th>
          <b-th class="text-center">Number of completed Lessons</b-th>          
          <b-th class="text-center">Action</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item, index) in sequences">
          <b-tr :key="item._id || index">
            <b-th class="text-center" :rowspan="item._idh">{{ index + 1 }}</b-th>
            <b-th class="text-center">
              {{ item.sequence_mark }}
            </b-th>
            <b-th class="text-center">
              <!-- <ui-component :component-data="item.name" /> -->
              <render-translatable-text :component-data="item.name" />
            </b-th>
            <b-th class="text-center">
              {{ item.required_progress_mark }}
            </b-th>
            <b-th class="text-center">
              <b-button
                variant="gradient-warning"
                style="margin-right: 5px"
                class="btn-icon"
                @click="editSequence(item._id)"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
              <b-button
                @click="confirmDelete(item._id)"
                variant="gradient-danger"
                class="btn-icon"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
            </b-th>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
import service from "../../service";

export default {
  props: {
    sequences: { type: Array, required: true },
  },
  methods: {
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure ?", {
          title: "Please Confirm",
          size: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.deleteSequence(id);
          }
        });
    },
    async deleteSequence(id) {
      await service.delete({ id: id });
      this.$emit("getList");
    },
    editSequence(id) {
      this.$router.push({
        name: "quest-sequence-detail",
        params: { sequence_id: id },
      });
    },
  },
};
</script>
